<template>
  <v-dialog scrollable persistent v-model="model" max-width="600">
    <material-card
      :title="
        $t('components.new_drugs.deactivate_drug_dialog.deactivate_drug_{0}', [
          drug.Name,
        ])
      "
      :color="$vuetify.theme.themes.light.error"
      icon="delete"
    >
      <v-card-text>
        <v-form :disabled="loading" ref="form" v-model="valid">
          <v-container>
            <div class="row">
              <div class="col-12 col-md-6">
                <pbas-date-picker
                  class="required"
                  :value="effectiveDate"
                  @update-date="effectiveDate = $event"
                  :label="$t('components.inmemorydependants.effective_date')"
                  :rules="[$rules.required]"
                ></pbas-date-picker>
              </div>
            </div>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text :loading="loading" @click="$emit('cancel')">
          {{ $t("globals.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click="save()"
          :disabled="!valid"
        >
          {{ $t("globals.deactivate") }}
        </v-btn>
      </v-card-actions>
      <error-handler :error="error"></error-handler>
    </material-card>
  </v-dialog>
</template>

<script>
import deepClone from "../../utils/deepClone";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";

export default {
  components: {
    ErrorHandler,
  },
  props: ["drug", "model"],
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    effectiveDate: null,
  }),
  methods: {
    ...mapActions("claims", ["deactivateDrug"]),
    async save() {
      try {
        await this.withLoad(
          this.deactivateDrug({
            effectiveDate: this.effectiveDate,
            id: this.drug.Id,
          })
        );
        this.$emit("saved");
      } catch (e) {
        this.error = e;
      }
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
